<template>
  <b-row>

    <!-- User Info: Left col -->
    <b-col
      cols="20"
      xl="12"
      class="d-flex justify-content-between flex-column"
    >
      <b-card
        no-body
        class="card-employee-task"
      >
        <b-card-header
          class="header-background"
        >
          <b-card-title>{{ $t('DEBTIA_GENERAL_INFORMATION') }}</b-card-title>
        </b-card-header>

        <!-- body -->
        <b-card-body>
          <b-row>
            <!-- User Info: Left col -->
            <b-col
              cols="12"
              xl="6"
              class="d-flex justify-content-between flex-column row-right-border"
            >
              <div
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{ $t('DEBTIA_NAME') }}
                    </h6>
                  </b-media-body>
                </b-media>
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-75">{{ userData.data.name ? userData.data.name : 'N/A' }}</small>
                </div>
              </div>
              <div
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{ $t('DEBTIA_USERNAME') }}
                    </h6>
                  </b-media-body>
                </b-media>
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-75">{{ userData.data.username ? userData.data.username : 'N/A' }}</small>
                </div>
              </div>
              <div
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{ $t('DEBTIA_EMAIL') }}
                    </h6>
                  </b-media-body>
                </b-media>
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-75"><a :href="'mailto:' + userData.data.email">{{ userData.data.email ? userData.data.email : 'N/A' }}</a></small>
                </div>
              </div>
              <div
                v-if="(userData.data.type === 'person' && userData.data.cpr) && userData.data.cpr.length === 11"
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{ $t('DEBTIA_CPR') }}
                    </h6>
                  </b-media-body>
                </b-media>
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-75">{{ userData.data.cpr ? userData.data.cpr : 'N/A' }}</small>
                </div>
              </div>
              <div
                v-if="(userData.data.type !== 'person' && userData.data.cvrcpr)"
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{ $t('DEBTIA_CVRCPR') }}
                    </h6>
                  </b-media-body>
                </b-media>
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-75">{{ userData.data.cvrcpr ? userData.data.cvrcpr : 'N/A' }}</small>
                </div>
              </div>
              <div
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{ $t('DEBTIA_PHONE') }}
                    </h6>
                  </b-media-body>
                </b-media>
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-75">{{ userData.data.phone ? userData.data.phone : 'N/A' }}</small>
                </div>
              </div>
              <div
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{ $t('DEBTIA_LOGIN') }}
                    </h6>
                  </b-media-body>
                </b-media>
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-75">{{ userData.data.loginStatus === '0' ? "Not Allowed" : "Allowed" }}</small>
                </div>
              </div>
              <div
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{ $t('DEBTIA_RKI_CUSTOMER_NUMBER') }}
                    </h6>
                  </b-media-body>
                </b-media>
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-75">{{ userData.data.rki_customer_id ? userData.data.rki_customer_id : 'N/A' }}</small>
                </div>
              </div>
              <div
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{ $t('DEBTIA_OPTED_OUT_NEWSLETTER') }}
                    </h6>
                  </b-media-body>
                </b-media>
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-75">{{ userData.data.opted_out_newsletter === 0 ? "No" : "Yes" }}</small>
                </div>
              </div>
            </b-col>
            <!-- User Info: Left col -->
            <b-col
              cols="12"
              xl="6"
              class="d-flex justify-content-between flex-column"
            >
              <div
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{ $t('DEBTIA_BILLING_EMAIL') }}
                    </h6>
                  </b-media-body>
                </b-media>
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-75"><a :href="'mailto:' + userData.data.billing_email">{{ userData.data.billing_email ? userData.data.billing_email : 'N/A' }}</a></small>
                </div>
              </div>
              <div
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{ $t('DEBTIA_CONTACT_PERSON') }}
                    </h6>
                  </b-media-body>
                </b-media>
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-75">{{ userData.data.contact_person ? userData.data.contact_person : 'N/A' }}</small>
                </div>
              </div>
              <div
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{ $t('DEBTIA_CLIENT_TYPE') }}
                    </h6>
                  </b-media-body>
                </b-media>
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-75">{{ userData.data.type }}</small>
                </div>
              </div>
              <div
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{ $t('DEBTIA_VAT_EXEMPTION') }}
                    </h6>
                  </b-media-body>
                </b-media>
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-75">{{ userData.data.vat_exempted === 0 ? $t('DEBTIA_NO') : $t('DEBTIA_YES') }}</small>
                </div>
              </div>
              <div
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{ $t('DEBTIA_COLLECTION_TYPE') }}
                    </h6>
                  </b-media-body>
                </b-media>
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-75">{{ userData.data.collection_type === 'own' ? $t('DEBTIA_OWN') : $t('DEBTIA_FOREIGN') }}</small>
                </div>
              </div>
              <div
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{ $t('DEBTIA_TERMSHEETCODE') }}
                    </h6>
                  </b-media-body>
                </b-media>
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-75">{{ userData.data.termSheetCode ? userData.data.termSheetCode : 'N/A' }}</small>
                </div>
              </div>
              <div
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{ $t('DEBTIA_MONITORING_TERMSHEETCODE') }}
                    </h6>
                  </b-media-body>
                </b-media>
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-75">{{ userData.data.monitoring_termsheetcode ? userData.data.monitoring_termsheetcode : 'N/A' }}</small>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-col>
    <b-col
      cols="12"
      xl="12"
      class="d-flex justify-content-between flex-column"
    >
      <b-card
        no-body
        class="card-employee-task"
      >
        <b-card-header
          class="header-background"
        >
          <b-card-title>{{ $t('DEBTIA_BANK_INFORMATION') }}</b-card-title>
        </b-card-header>

        <!-- body -->
        <b-card-body>
          <b-row>
            <!-- User Info: Left col -->
            <b-col
              cols="12"
              xl="6"
              class="d-flex justify-content-between flex-column row-right-border"
            >
              <div
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{ $t('DEBTIA_BANK_BRANCH_NO') }}
                    </h6>
                  </b-media-body>
                </b-media>
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-75">{{ userData.data.bank_branch_no ? userData.data.bank_branch_no : 'N/A' }}</small>
                </div>
              </div>
              <div
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{ $t('DEBTIA_IBAN') }}
                    </h6>
                  </b-media-body>
                </b-media>
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-75">{{ userData.data.iban ? userData.data.iban : 'N/A' }}</small>
                </div>
              </div>
            </b-col>
            <!-- User Info: Left col -->
            <b-col
              cols="12"
              xl="6"
              class="d-flex justify-content-between flex-column"
            >
              <div
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{ $t('DEBTIA_BANK_ACCOUNT_NO') }}
                    </h6>
                  </b-media-body>
                </b-media>
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-75">{{ userData.data.bank_account_no ? userData.data.bank_account_no : 'N/A' }}</small>
                </div>
              </div>
              <div
                class="employee-task d-flex justify-content-between align-items-center"
              >
                <b-media no-body>
                  <b-media-body class="my-auto">
                    <h6 class="mb-0">
                      {{ $t('DEBTIA_SWIFTCODE') }}
                    </h6>
                  </b-media-body>
                </b-media>
                <div class="d-flex align-items-center">
                  <small class="text-muted mr-75">{{ userData.data.swift_code ? userData.data.swift_code : 'N/A' }}</small>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-col>
    <b-col
      cols="21"
      xl="6"
      class="d-flex justify-content-between flex-column"
    >
      <b-card
        no-body
        class="card-employee-task"
      >
        <b-card-header
          class="header-background"
        >
          <b-card-title>{{ $t('DEBTIA_ADDRESS') }}</b-card-title>
        </b-card-header>

        <!-- body -->
        <b-card-body>
          <div
            class="employee-task d-flex justify-content-between align-items-center"
          >
            <b-media no-body>
              <b-media-body class="my-auto">
                <h6 class="mb-0">
                  {{ $t('DEBTIA_HOUSE_NUMBER') }}
                </h6>
              </b-media-body>
            </b-media>
            <div class="d-flex align-items-center">
              <small class="text-muted mr-75">{{ userData.data.address && userData.data.address.house_number ? userData.data.address.house_number : 'N/A' }}</small>
            </div>
          </div>
          <div
            class="employee-task d-flex justify-content-between align-items-center"
          >
            <b-media no-body>
              <b-media-body class="my-auto">
                <h6 class="mb-0">
                  {{ $t('DEBTIA_ROAD_NAME') }}
                </h6>
              </b-media-body>
            </b-media>
            <div class="d-flex align-items-center">
              <small class="text-muted mr-75">{{ userData.data.address && userData.data.address.road_name ? userData.data.address.road_name : 'N/A' }}</small>
            </div>
          </div>
          <div
            class="employee-task d-flex justify-content-between align-items-center"
          >
            <b-media no-body>
              <b-media-body class="my-auto">
                <h6 class="mb-0">
                  {{ $t('DEBTIA_PLACE_NAME') }}
                </h6>
              </b-media-body>
            </b-media>
            <div class="d-flex align-items-center">
              <small class="text-muted mr-75">{{ userData.data.address && userData.data.address.place ? userData.data.address.place : 'N/A' }}</small>
            </div>
          </div>
          <div
            class="employee-task d-flex justify-content-between align-items-center"
          >
            <b-media no-body>
              <b-media-body class="my-auto">
                <h6 class="mb-0">
                  {{ $t('DEBTIA_ZIP_CODE') }}
                </h6>
              </b-media-body>
            </b-media>
            <div class="d-flex align-items-center">
              <small class="text-muted mr-75">{{ userData.data.address && userData.data.address.zip_code ? userData.data.address.zip_code : 'N/A' }}</small>
            </div>
          </div>
          <div
            class="employee-task d-flex justify-content-between align-items-center"
          >
            <b-media no-body>
              <b-media-body class="my-auto">
                <h6 class="mb-0">
                  {{ $t('DEBTIA_CITY') }}
                </h6>
              </b-media-body>
            </b-media>
            <div class="d-flex align-items-center">
              <small class="text-muted mr-75">{{ userData.data.address && userData.data.address.city ? userData.data.address.city : 'N/A' }}</small>
            </div>
          </div>
          <div
            class="employee-task d-flex justify-content-between align-items-center"
          >
            <b-media no-body>
              <b-media-body class="my-auto">
                <h6 class="mb-0">
                  {{ $t('DEBTIA_COUNTRY') }}
                </h6>
              </b-media-body>
            </b-media>
            <div class="d-flex align-items-center">
              <small class="text-muted mr-75">{{ userData.data.address && userData.data.address.country ? userData.data.address.country : 'N/A' }}</small>
            </div>
          </div>
        </b-card-body>
      </b-card>
    </b-col>
    <b-col
      cols="21"
      xl="6"
      class="d-flex justify-content-between flex-column"
    >
      <b-card
        no-body
        class="card-employee-task"
      >
        <b-card-header
          class="header-background"
        >
          <b-card-title>{{ $t('DEBTIA_BILLING_ADDRESS') }}</b-card-title>
        </b-card-header>

        <!-- body -->
        <b-card-body>
          <div
            class="employee-task d-flex justify-content-between align-items-center"
          >
            <b-media no-body>
              <b-media-body class="my-auto">
                <h6 class="mb-0">
                  {{ $t('DEBTIA_HOUSE_NUMBER') }}
                </h6>
              </b-media-body>
            </b-media>
            <div class="d-flex align-items-center">
              <small class="text-muted mr-75">{{ getBillingHouseNumber() }}</small>
            </div>
          </div>
          <div
            class="employee-task d-flex justify-content-between align-items-center"
          >
            <b-media no-body>
              <b-media-body class="my-auto">
                <h6 class="mb-0">
                  {{ $t('DEBTIA_ROAD_NAME') }}
                </h6>
              </b-media-body>
            </b-media>
            <div class="d-flex align-items-center">
              <small class="text-muted mr-75">{{ getBillingRoadName() }}</small>
            </div>
          </div>
          <div
            class="employee-task d-flex justify-content-between align-items-center"
          >
            <b-media no-body>
              <b-media-body class="my-auto">
                <h6 class="mb-0">
                  {{ $t('DEBTIA_PLACE_NAME') }}
                </h6>
              </b-media-body>
            </b-media>
            <div class="d-flex align-items-center">
              <small class="text-muted mr-75">{{ getBillingPlaceName() }}</small>
            </div>
          </div>
          <div
            class="employee-task d-flex justify-content-between align-items-center"
          >
            <b-media no-body>
              <b-media-body class="my-auto">
                <h6 class="mb-0">
                  {{ $t('DEBTIA_ZIP_CODE') }}
                </h6>
              </b-media-body>
            </b-media>
            <div class="d-flex align-items-center">
              <small class="text-muted mr-75">{{ getBillingZipCode() }}</small>
            </div>
          </div>
          <div
            class="employee-task d-flex justify-content-between align-items-center"
          >
            <b-media no-body>
              <b-media-body class="my-auto">
                <h6 class="mb-0">
                  {{ $t('DEBTIA_CITY') }}
                </h6>
              </b-media-body>
            </b-media>
            <div class="d-flex align-items-center">
              <small class="text-muted mr-75">{{ getBillingCity() }}</small>
            </div>
          </div>
          <div
            class="employee-task d-flex justify-content-between align-items-center"
          >
            <b-media no-body>
              <b-media-body class="my-auto">
                <h6 class="mb-0">
                  {{ $t('DEBTIA_COUNTRY') }}
                </h6>
              </b-media-body>
            </b-media>
            <div class="d-flex align-items-center">
              <small class="text-muted mr-75">{{ getBillingCountry() }}</small>
            </div>
          </div>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BCard, BRow, BCol, BCardHeader, BCardTitle, BCardBody, BMedia, BMediaBody,
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import useUsersList from '../clients-list/useClientsList'

export default {
  components: {
    BCard, BRow, BCol, BCardHeader, BCardTitle, BCardBody, BMedia, BMediaBody,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const { resolveUserRoleVariant } = useUsersList()
    return {
      avatarText,
      resolveUserRoleVariant,
    }
  },
  methods: {
    getBillingHouseNumber() {
      let houseNumber = ''
      if (this.userData.data.billing_address) {
        houseNumber = this.userData.data.billing_address.house_number ? this.userData.data.billing_address.house_number : 'N/A'
      } else {
        houseNumber = this.userData.data.address.house_number ? this.userData.data.address.house_number : 'N/A'
      }
      return houseNumber
    },
    getBillingRoadName() {
      let roadName = ''
      if (this.userData.data.billing_address) {
        roadName = this.userData.data.billing_address.road_name ? this.userData.data.billing_address.road_name : 'N/A'
      } else {
        roadName = this.userData.data.address.road_name ? this.userData.data.address.road_name : 'N/A'
      }
      return roadName
    },
    getBillingPlaceName() {
      let place = ''
      if (this.userData.data.billing_address) {
        place = this.userData.data.billing_address.place ? this.userData.data.billing_address.place : 'N/A'
      } else {
        place = this.userData.data.address.place ? this.userData.data.address.place : 'N/A'
      }
      return place
    },
    getBillingZipCode() {
      let zipCode = ''
      if (this.userData.data.billing_address) {
        zipCode = this.userData.data.billing_address.zip_code ? this.userData.data.billing_address.zip_code : 'N/A'
      } else {
        zipCode = this.userData.data.address.zip_code ? this.userData.data.address.zip_code : 'N/A'
      }
      return zipCode
    },
    getBillingCity() {
      let city = ''
      if (this.userData.data.billing_address) {
        city = this.userData.data.billing_address.city ? this.userData.data.billing_address.city : 'N/A'
      } else {
        city = this.userData.data.address.city ? this.userData.data.address.city : 'N/A'
      }
      return city
    },
    getBillingCountry() {
      let country = ''
      if (this.userData.data.billing_address) {
        country = this.userData.data.billing_address.country ? this.userData.data.billing_address.country : 'N/A'
      } else {
        country = this.userData.data.address.country ? this.userData.data.address.country : 'N/A'
      }
      return country
    },
  },
}
</script>

<style>
.row-right-border {
  border-right: 1px solid #d9d9d9;
}

.header-background {
  background-color: #7c9b98  !important;
  margin-bottom: 20px;
}

.header-background h4.card-title{
  color: #ffffff;
}
</style>
